import { useState } from "react";
import axios from "axios";

export default function KataSlipUpload() {
  const [formData, setFormData] = useState({
    srNo: "",
    clientName: "",
    commodityName: "",
    varietyName: "",
    warehouseName: "",
    quantity: "",
    noOfBags: "",
  });

  const handleUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const form = new FormData();
      form.append("pdf", file);

      const res = await axios.post(
        "https://irc.zentelex.com/api/extract-kataslip",
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // ✅ Auto-fill form
      setFormData({
        srNo: res.data.srNo || "",
        clientName: res.data.clientName || "",
        commodityName: res.data.commodityName || "",
        varietyName: res.data.varietyName || "",
        warehouseName: res.data.warehouseName || "",
        quantity: res.data.quantity || "",
        noOfBags: res.data.noOfBags || "",
      });
    } catch (error) {
      console.error("PDF upload failed", error);
      alert("Failed to extract PDF data");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Kata Slip PDF Upload</h2>

      <input type="file" accept="application/pdf" onChange={handleUpload} />

      <hr />

      <h3>Extracted Data</h3>

      <input placeholder="Serial No" value={formData.srNo} readOnly />
      <br />

      <input placeholder="Client Name" value={formData.clientName} readOnly />
      <br />

      <input placeholder="Commodity" value={formData.commodityName} readOnly />
      <br />

      <input placeholder="Variety" value={formData.varietyName} readOnly />
      <br />

      <input placeholder="Warehouse" value={formData.warehouseName} readOnly />
      <br />

      <input placeholder="Quantity" value={formData.quantity} readOnly />
      <br />

      <input placeholder="No of Bags" value={formData.noOfBags} readOnly />
    </div>
  );
}
